import { stateOptions } from '../commonStateTaxData';

export const basicInfoQuestions = [
  {
    id: 'employee_first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_name',
    title: 'Middle initial',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Filing status',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_at_single_rate',
        shortName: 'Married, but withhold at higher single rate',
      },
    ],
  },
];

export const allowancesQuestions = [
  {
    id: 'dependents',
    title:
      'Allowance for dependents: Enter the number of dependents you will claim on your tax return. Do not claim yourself or your spouse or dependents that your spouse has already claimed on his or her Form OK-W-4.',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_allowances',
    title:
      'Additional Allowances: You may claim additional allowances if you itemize your deductions or have other state tax deductions or credit that lower your tax. Enter the number of additional allowances you would like to claim.',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title:
      'Additional Withholding: If you expect to have a balance due (as a result of interest income, dividends, income from a part-time job, etc.) on your tax return, you may request your employer to withhold an additional amount of tax from each pay period. To calculate the amount needed, divide the amount of the expected balance due by the number of pay periods in a year. Enter the additional amount to be withheld each pay period here.',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const exemptionQuestions = [
  {
    id: 'exemption_reason',
    title: 'Select the appropriate reason you are claiming an exemption from withholding.',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'refund_ok_income_tax',
        shortName:
          'You had a right to a refund of all of your Oklahoma income tax withheld last year because you had no tax liability and this year you expect a refund of all Oklahoma income tax withheld because you expect to have no tax liability.',
      },
      {
        codeValue: 'servicemember_civil_relief',
        shortName:
          'You meet the conditions set forth under the Servicemember Civil Relief Act, as amended by the Military Spouses Residency Relief Act and have no Oklahoma tax liability',
      },
      {
        codeValue: 'military_income_deduction',
        shortName:
          'Income earned as a member of any active duty component of the Armed Forces of the United States is eligible for the military income deduction',
      },
    ],
  },
];
